import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import CashoutHistoryTableRow from "./CashoutHistoryTableRow";

export default observer(function CashoutHistoryTableRows() {
	const store = useContext(MyBetsStoreContext);

	if (store == null) {
		return null;
	}

	return (
		<>
			{store.cashoutStore.cashoutHistory?.betSlipCashoutHistoryValues?.map(
				(value, index) => (
					<CashoutHistoryTableRow
						key={value.timestamp}
						count={index + 1}
						rowData={value}
					/>
				)
			)}
		</>
	);
});
